import React from 'react'
import { defineMessages, injectIntl } from 'react-intl'
import { Title } from '../components'

import ContactSection from '../ContactSection/ContactSection'

import './NotFoundPage.scss'

const messages = defineMessages({
  header: {
    id: 'notFound.header',
    defaultMessage: 'Stránka nebyla nalezena',
  },
  message: {
    id: 'notFound.message',
    defaultMessage: 'Bohuže Vámi hledaná stránka nebyla nalezena',
  },
  clickText: {
    id: 'notFound.clickText',
    defaultMessage: 'klikněte zde pro přesun na hlavní stranu',
  },
  contactHeader: {
    id: 'notFound.contact.header',
    defaultMessage: 'Kontaktujte nás',
  },
})

const NotFoundPage = ({ intl }) => (
  <main className="page">
    <Title message="404" />
    <section className="not-found-section">
      <div className="overlay">
        <span>404</span>
      </div>
      <div className="logo">
        <a href="/"><img src="/images/logo.png" alt="stadyum logo" /></a>
      </div>
      <h1 className="message">
        <p>{intl.formatMessage(messages.message)}<br /><a href="/">{intl.formatMessage(messages.clickText)}</a></p>
      </h1>
    </section>
    <ContactSection replaceHeader={intl.formatMessage(messages.contactHeader)} />
  </main>
)

NotFoundPage.propTypes = {
  intl: React.PropTypes.object.isRequired,
}

export default injectIntl(NotFoundPage)



// WEBPACK FOOTER //
// ./src/browser/NotFound/NotFoundPage.js